module.exports = __webpack_public_path__ + "static/media/undraw_real-time_sync_o57k.10a054ce.svg";